import * as React from 'react';
import { useInvalidSection } from '../metroline/invalid-section';
import { importSetConfiguration, getImportSetRoute } from '../metroline/import-set-configuration';
import { ImportSetItem } from '../types-store';
import { ImportSetFormProps } from '../types';
import { ImportSetFormRenderer } from './import-set-form-renderer';

export const ImportSetFormSections: React.FC<ImportSetFormProps> = ({
  actionType, formState, mainLanguage, options, section, locale, translation,
  showTranslations, translationAdminAccess,
  saveImportSet, duplicateImportSet, deleteImportSet, updateValidation, resetValidation, displayError,
  updateItem, changeLanguage, copyLanguageToAll, loadOptions, switchTranslationsToggle
}) => {

  const scrollViewUrl = getImportSetRoute(actionType, formState.importSetItem?.id);

  const configuration = importSetConfiguration(
    actionType,
    formState.importSetItem?.id,
    formState.validation
  );

  const [invalidSection, updateInvalidSection] = useInvalidSection(configuration, formState.validation);

  const onSaveImportSet = (item: ImportSetItem) => {
    updateInvalidSection(undefined);
    saveImportSet(item);
  };

  return <ImportSetFormRenderer
    showTranslations={showTranslations}
    switchTranslationsToggle={switchTranslationsToggle}
    actionType={actionType}
    formState={formState}
    mainLanguage={mainLanguage}
    saveImportSet={onSaveImportSet}
    duplicateImportSet={duplicateImportSet}
    deleteImportSet={deleteImportSet}
    updateItem={updateItem}
    changeLanguage={changeLanguage}
    copyLanguageToAll={copyLanguageToAll}
    options={options}
    loadOptions={loadOptions}
    updateValidation={updateValidation}
    resetValidation={resetValidation}
    displayError={displayError}
    locale={locale}
    validation={formState.validation}
    translation={translation}
    label={translation.manage_import_sets}
    section={section}
    initialSection={section}
    configuration={configuration}
    scrollViewUrl={scrollViewUrl}
    invalidSection={invalidSection}
    translationAdminAccess={translationAdminAccess} />;
};
